import { createFileRoute, notFound } from '@tanstack/react-router';
import { WorkflowView } from '~/components/ui/workflow/WorkflowView';
import { canAccess } from '~/utils/rbac';

export const Route = createFileRoute('/_authLayout/workflows/')({
  beforeLoad: async () => {
    if (!canAccess('workflow')) {
      throw notFound();
    }
  },
  component: WorkflowsPage,
});

function WorkflowsPage() {
  return <WorkflowView />;
}
